/**
 * Created by Jerker Nord on 2024-03-12.
 */
import {LonerMaxWinView} from "../../base/LonerMaxWinView";
import {Loner} from "../../../Loner";
import {LonerSound} from "../../../sound/LonerSound";
import {
    LonerPinTheWinResultPresentation
} from "../../../presentationrunners/features/pinthewin/LonerPinTheWinResultPresentation";

export class LonerPinTheWinMaxWinView extends LonerMaxWinView{

    constructor() {
        super();
        this.name = "LonerPinTheWinMaxWinView";
    }

    public endMaxWin(): void {
        Loner.pinTheWinMainView.showHideBg(false,0.001);
        Loner.pinTheWinMainView.clearTrail();
        Loner.pinTheWinMainView.setVhsMulti(1);
        Loner.pinTheWinMainView.hideVhsMulti(0.001);
        Loner.pinTheWinMainView.setPinPosAndVisibility(2, 2, false, 0.001);
        Loner.pinTheWinMainView.hideCornerMultipliers(0.001);
        Loner.pinTheWinMainView.visible = false;
        Loner.allReelView.enableAllViews();
        Loner.pinTheWinOutroView.hideOutro(Loner.isWinBelowStake());
        Loner.foregroundView.clearAnimationTrack(2);
        Loner.logoView.show();
        Loner.tvMessageView.show();
        super.endMaxWin();
    }

    protected playMaxWinLoop():void {
        Loner.pinTheWinMainView.stopMaxWinSymbolBlink();
        Loner.soundPlayer.stopSound(LonerSound.PTW_LOOP);
        LonerPinTheWinResultPresentation.setSubTlAddedToMainTlFlag(false);
        super.playMaxWinLoop();
    }
}